import React from 'react';

import { useSearchRelationshipsContact } from '../../modules/RelationshipsApiProxy';

import { SearchCustomersPanel } from './SearchCustomersPanel';
import { PanelConfig } from './types';

export const relationshipsApiCustomerPanelConfig: PanelConfig = {
    title: 'Search Relationships API | Customer Endpoint',
    filters: [
      { label: 'Email', name: 'email', optional: true },
      { label: 'Phone', name: 'phone', optional: true },
    ],
    url: '/relationships-api-proxy/contact',
    queryKeys: ['email', 'phone'],
  };

export function SearchRelationshipsApiCustomersPanel() {
  return <SearchCustomersPanel key={relationshipsApiCustomerPanelConfig.title} config={relationshipsApiCustomerPanelConfig} useQueryHook={useSearchRelationshipsContact} />
};
